<template>
  <!-- Thin wrapper: same component as ProductAutoComplete, pointed at the
       cleaned/verified products service. Kept so existing call sites and the
       component name don't change. -->
  <ProductAutoComplete
      :value="value"
      :forceSelection="forceSelection"
      :verified="true"
      v-on="$listeners"
  />
</template>

<script>
import ProductAutoComplete from "./ProductAutoComplete.vue";

export default {
  components: { ProductAutoComplete },
  props: {
    value: {
      type: [Object, String],
      default: () => {
        return ""
      }
    },
    forceSelection: {
      type: Boolean,
      default: false
    },
  },
};
</script>
